import apiClient from './client';
import { getAllPages } from './pagination';

// Images of a disease, finding or association (`targetKind` "diseases",
// "findings" or "associations"). An image is {id, title, description, body_site,
// url, like_count, liked_by_me, flag_counts, created_by, mine}. `url` is a signed
// link that expires after an hour, so lists are refetched rather than cached long.

// The largest upload the API accepts
export const MAX_IMAGE_BYTES = 20 * 1024 * 1024;

export const getImages = (targetKind, id) => getAllPages(`/${targetKind}/${id}/images`);

// The file and its fields in one multipart request
export const uploadImage = (targetKind, id, { file, title = '', description = '', bodySite = '' }) => {
  const form = new FormData();
  form.append('file', file);
  form.append('target_kind', targetKind);
  form.append('target_id', String(id));
  form.append('title', title);
  form.append('description', description);
  form.append('body_site', bodySite);
  return apiClient.post('/images', form).then((r) => r.data);
};

// Only the changed fields, of {title, description, body_site}
export const updateImage = (id, payload) =>
  apiClient.patch(`/images/${id}`, payload).then((r) => r.data);

export const deleteImage = (id) => apiClient.delete(`/images/${id}`).then(() => undefined);
